/*
 * @Date: 2025-04-01 17:52:01
 * @Description:个体税金及服务费订单
 */
import IndividualProxyFeeList from '../views/individual-proxy-fee-list.vue';
export const route = [
  {
    path: '/dbgys/order-mgmt/individual-proxy-fee',
    name: 'individual-proxy-fee',
    meta: {
      title: '个体税金及服务费订单'
    },
    component: IndividualProxyFeeList
  }
];
